<template>
  <v-autocomplete
    label="Candidate"
    :loading="loading"
    :search-input.sync="candidateEmail"
    :items="candidates" item-text="email" item-value="id" return-object
    :value="value"
    no-filter
    hide-no-data
    clearable
    :required="required" :rules="rules || []"
    @input="handleInput"
    menu-props="closeOnClick"
  >
    <template slot="item" slot-scope="{ item: candidate }">
      <v-list-tile-content>
        <v-list-tile-title>{{ candidate.email }}</v-list-tile-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>

<script>
// Helpers
import _ from 'lodash'

// Vue Component
export default {
  props: {
    value: { required: true },
    required: { type: Boolean, default: () => false },
    rules: { type: Array },
  },
  data() {
    return {
      loading: false,
      candidateEmail: `${this.value.email}`,
      candidates: [],
    }
  },
  watch: {
    candidateEmail: _.debounce(function(email) {
      // email is null on initial load
      if (email && email.length > 2) {
        // Update options
        this.loading = true
        Vue.$http
          .get(`admin/candidates?search=${email}`)
          .then(({ data }) => {
            this.candidates = data.items.filter((c) => !c.profile.id)
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => (this.loading = false))
      } else {
        this.candidates = []
      }
    }, 150),
  },
  methods: {
    handleInput(candidate) {
      this.$emit('input', candidate)
    },
  },
}
</script>
